import styled from 'styled-components';

import grid from '~/styles/grid';

export const Container = styled.div`
  // TODO(Cabral): Ajustar Header do sistema para remover esse margin top
  min-height: 100%;
`;

export const HeaderContainer = styled.header`
  padding: ${grid.lg} 0 ${grid.md} 0;
`;

export const HeaderTitle = styled.h3`
  font-size: 171.43%;
  font-weight: 600;
  margin-bottom: 0;
`;

export const HeaderCloseButton = styled.button`
  background: none;
  border: none;
  height: ${grid.xl};
  position: absolute;
  right: 0;
  top: 0;

  // TODO(Cabral): Ajustar Header do sistema para remover esse top de 80px
  margin-right: ${grid.lg};
  margin-top: ${grid.lg};
  z-index: 1;
`;
